export const selector = 'dbAEventValueKeyFilter';

/* @ngInject */
export default function EventValueKeyFilterDirective() {
    return {
        restrict: 'A',

        link(scope, element) {
            let codes = [
                // +
                187,
                // -
                189,
                // e
                69
            ];

            element.on('keydown', keyHandler);

            scope.$on('$destroy', () => {
                element.off('keydown', keyHandler);
            });

            function keyHandler(event) {
                let shouldIgnore = codes.indexOf(event.keyCode || event.which) >= 0;

                if (shouldIgnore) {
                    event.preventDefault();
                }

                return !shouldIgnore;
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/component/modals/component/event-edit-modal/directive/event-value-key-filter/event-value-key-filter.directive.js